import RouteManager, { PAGE_ROUTES } from "../../managers/RouteManager";
import { COLUMN_CODE, TableManger, TABLES } from "../../managers/TableManger";
import AppManager from "../../managers/AppManager";
import Utility from "../../utility/Utility";
import FormService from "../../services/form";
import React from "react";
import TemplateManager from "./templates/TemplateManager";
import template_0 from "../../assets/formTemplates/defaultTemplate_new2.png";
import template_1 from "../../assets/formTemplates/template_1.png";
import template_2 from "../../assets/formTemplates/template_2.png";
import template_3 from "../../assets/formTemplates/template_3_new.png";
import template_4 from "../../assets/formTemplates/template_4.png";
import template_5 from "../../assets/formTemplates/template_5_new.png";
import template_6 from "../../assets/formTemplates/template_6.png";
import template_7 from "../../assets/formTemplates/template_7_new.png";
import template_8 from "../../assets/formTemplates/template_8.png";
import template_9 from "../../assets/formTemplates/template_9.png";
import template_10 from "../../assets/formTemplates/template_10.png";
import FormHeader from "./FormHeader";

import { showToast, TOAST_TYPE } from "deskera-ui-library";

export default class FormManager {
  static formData;
  static directLink = null;

  static status = {
    ACTIVE: [1],
    IN_ACTIVE: [2],
  };

  ////////////////////////////////////////////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////////////

  static getAllCreationSteps() {
    const formId = this.getFormRecordId() ? "/" + this.getFormRecordId() : "";
    let steps = [
      {
        title: "Select Template",
        onClick: () => {
          RouteManager.navigateToPage(
            PAGE_ROUTES.SELECT_FORM_TEMPLATE + formId
          );
        },
      },
      {
        title: FormManager.isPageDataAvailable() ? "Edit Design" : "Design",
        onClick: () => {
          if (FormManager.isPageDataAvailable()) {
            RouteManager.navigateToPage(PAGE_ROUTES.FORM_BUILDER + formId);
          } else {
            showToast("Please select template", TOAST_TYPE.FAILURE);
          }
        },
      },
      {
        title: FormManager.isPageDataAvailable()
          ? "Publish Details"
          : "Publish",
        onClick: () => {
          if (FormManager.isPageDataAvailable()) {
            RouteManager.navigateToPage(PAGE_ROUTES.FORM_DOMAIN + formId);
          } else {
            showToast("Please save design to proceed", TOAST_TYPE.FAILURE);
          }
        },
      },
    ];
    return steps;
  }

  ////////////////////////////////////////////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////////////
  static isPageDataAvailable() {
    return !(
      FormManager.formData === null || FormManager.formData === undefined
    );
  }

  static setFormData(response) {
    FormManager.formData = response;
  }

  static getFormData() {
    return FormManager.formData || "";
  }

  ////////////////////////////////////////////////////////////////////////////////////

  static getFormRecordId() {
    if (!FormManager.isPageDataAvailable()) {
      return null;
    }

    return FormManager.formData.data._id;
  }

  ////////////////////////////////////////////////////////////////////////////////////

  static getDirectLink() {
    if (!FormManager.isPageDataAvailable()) {
      return "URL not found";
    }

    let directLink =
      FormManager.formData.data.cells[
        FormManager.getColumnId(COLUMN_CODE.JOB_FORMS.DIRECT_LINK)
      ];

    return AppManager.generateDirectLink(directLink);
  }

  static getFormStatus() {
    if (!FormManager.isPageDataAvailable()) {
      return false;
    }

    let status =
      FormManager.formData.data.cells[
        FormManager.getColumnId(COLUMN_CODE.JOB_FORMS.STATUS)
      ];

    status = JSON.stringify(status);

    return status === "[1]";
  }

  ////////////////////////////////////////////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////////////

  static getFormJSONData() {
    if (!FormManager.isPageDataAvailable()) {
      return [];
    }

    let jsonData =
      FormManager.formData.data.cells[
        FormManager.getColumnId(COLUMN_CODE.JOB_FORMS.JSON_DATA)
      ];

    return Utility.decodeJSON(jsonData);
  }

  ////////////////////////////////////////////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////////////

  // static getEmbeddedFormId() {
  //   if (!FormManager.isPageDataAvailable()) {
  //     return "URL not found";
  //   }
  //
  //   let directLink =
  //     FormManager.formData.data.cells[
  //       FormManager.getColumnId(COLUMN_CODE.FORMS.DIRECT_LINK)
  //       ];
  //
  //   if (directLink && directLink.includes(PAGE_ROUTES.PUBLIC_PAGE_PATH)) {
  //     let splitDirectLink = directLink.split("/");
  //     return splitDirectLink[splitDirectLink.length - 1];
  //   }
  //
  //   return directLink;
  // }

  // static getEmbeddedFormScript() {
  //   return (
  //     '<div id="deskera-form" data-dkcrmbaseurl="' + ApiConstants.URL.BASE + '" data-formid="' +
  //     FormManager.getEmbeddedFormId() +
  //     '"></div>\n' +
  //     '<script type="text/javascript" src="' +
  //     ApiConstants.FORM_SUBMISSION_URL +
  //     '"></script>\n' +
  //     '<script type="text/javascript" src="' +
  //     ApiConstants.LOAD_SCRIPTS_URL +
  //     '"></script>\n' +
  //     '<script type="text/javascript" src="' +
  //     ApiConstants.FORM_EMBEDDED_URL +
  //     '"></script>'
  //   );
  // }

  static getEmbeddedFormScript() {
    return (
      '<embed type="text/html" src="' +
      FormManager.getDirectLink() +
      '" width="1300" height="1200">'
    );
  }

  ////////////////////////////////////////////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////////////

  static getRequestToSaveForm(formData) {
    let data = {};
    data[this.getColumnId(COLUMN_CODE.JOB_FORMS.NAME)] = formData.formName;
    data[this.getColumnId(COLUMN_CODE.JOB_FORMS.SEGMENT_ID)] = this.getSegmentDataForForm(formData.segmentId);
    data[this.getColumnId(COLUMN_CODE.JOB_FORMS.HTML_DATA)] = formData.html;
    data[this.getColumnId(COLUMN_CODE.JOB_FORMS.JSON_DATA)] = formData.json;
    data[this.getColumnId(COLUMN_CODE.JOB_FORMS.HASH)] = formData.hash;
    data[this.getColumnId(COLUMN_CODE.JOB_FORMS.CUSTOM_DOMAIN)] = formData.domain;
    data[this.getColumnId(COLUMN_CODE.JOB_FORMS.VISITORS)] = 0;
    data[this.getColumnId(COLUMN_CODE.JOB_FORMS.CLICKS)] = 0;
    data[this.getColumnId(COLUMN_CODE.JOB_FORMS.STATUS)] =
      FormManager.status.ACTIVE;
    data[this.getColumnId(COLUMN_CODE.JOB_FORMS.PUBLISHED)] = true;
    data[this.getColumnId(COLUMN_CODE.JOB_FORMS.JOB_PIPELINE_ID)] = this.getPipelineDataForForm(formData.pipelineId);
    return data;
  }

  static getRequestToUpdateForm(formData) {
    let data = {};
    data[this.getColumnId(COLUMN_CODE.JOB_FORMS.HTML_DATA)] = formData.html;
    data[this.getColumnId(COLUMN_CODE.JOB_FORMS.JSON_DATA)] = formData.json;
    data[this.getColumnId(COLUMN_CODE.JOB_FORMS.SEGMENT_ID)] = this.getSegmentDataForForm(formData.segmentId);
    data[this.getColumnId(COLUMN_CODE.JOB_FORMS.PUBLISHED)] = true;
    data[this.getColumnId(COLUMN_CODE.JOB_FORMS.JOB_PIPELINE_ID)] = this.getPipelineDataForForm(formData.pipelineId);
    return data;
  }

  static getRequestToUpdateStatus(isActive) {
    let data = {};
    data[this.getColumnId(COLUMN_CODE.JOB_FORMS.STATUS)] =
      isActive === true
        ? FormManager.status.ACTIVE
        : FormManager.status.IN_ACTIVE;
    data[this.getColumnId(COLUMN_CODE.JOB_FORMS.PUBLISHED)] = true;
    return data;
  }

  ////////////////////////////////////////////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////////////

  static getColumnId(columnCode) {
    return TableManger.getColumnId(TABLES.JOB_FORMS, columnCode);
  }

  ////////////////////////////////////////////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////////////

  static fetchPageDataById(recordId, callback) {
    FormService.getData(
      recordId,
      (response) => {
        FormManager.setFormData({ data: response });
        callback && callback();
      },
      (error) => {}
    );
  }

  ////////////////////////////////////////////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////////////

  static getHeader() {
    return <FormHeader title={"Form Templates"} stepperIndex={0} />;
  }

  static navigateToBuilder() {
    RouteManager.navigateToPage(PAGE_ROUTES.FORM_BUILDER);
  }

  static setSelectedTemplateId(id) {
    TemplateManager.setSelectedTemplateId(id);
  }

  static getSelectedTemplateId() {
    return TemplateManager.getSelectedTemplateId();
  }

  static getAllTemplates() {
    return [
      template_0,
      template_3,
      template_5,
      template_7
    ];
  }

  static getSegmentDataForForm(segmentsData) {
    let segments = [1];
    if (Array.isArray(segmentsData)) {
      segments = segmentsData;
    }
    return segments;
  }

  static getPipelineDataForForm(pipelineData) {
    let pipelines = [];
    if (Array.isArray(pipelineData)) {
      pipelines = pipelineData;
    }
    return pipelines;
  }

  ////////////////////////////////////////////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////////////
}
